export default "__VITE_ASSET__BhdWZ2Qm__"